import { render } from "./AllergyFormDialog.vue?vue&type=template&id=ffb201da&scoped=true"
import script from "./AllergyFormDialog.vue?vue&type=script&lang=js"
export * from "./AllergyFormDialog.vue?vue&type=script&lang=js"

import "./AllergyFormDialog.vue?vue&type=style&index=0&id=ffb201da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb201da"]])

export default __exports__